import { render } from "./CabinetMinisterForm.vue?vue&type=template&id=814e4944&scoped=true&ts=true"
import script from "./CabinetMinisterForm.ts?vue&type=script&lang=ts"
export * from "./CabinetMinisterForm.ts?vue&type=script&lang=ts"

import "./CabinetMinisterForm.scss?vue&type=style&index=0&id=814e4944&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814e4944"]])

export default __exports__